var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "content__filter" }, [
      (_vm.page.in_sections && Object.keys(_vm.page.in_sections).length) ||
      (_vm.page.sections && Object.keys(_vm.page.sections).length)
        ? _c("div", { staticClass: "search__filter" }, [
            Object.keys(_vm.page.in_sections).length && _vm.page.in_sections
              ? _c(
                  "div",
                  {
                    staticClass:
                      "search__filter-box search__filter-box_type_toggle",
                  },
                  [
                    _c("div", { staticClass: "search__filter-box-title" }, [
                      _vm._v("\n          в названиях разделов\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "search__filter-box-nav" }, [
                      _c("span", {
                        staticClass: "search__filter-box-nav-current",
                      }),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "search__filter-box-nav-list" },
                        _vm._l(
                          _vm.page.in_sections,
                          function (value, name, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass: "search__filter-box-nav-item",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "search__filter-box-nav-link",
                                    class: {
                                      hide:
                                        index >= _vm.maxSection &&
                                        !_vm.isShowMoreInSections,
                                    },
                                    attrs: { href: "/catalog/" + name + "/" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(value) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    Object.keys(_vm.page.sections).length > _vm.maxSection &&
                    !_vm.isShowMoreInSections
                      ? _c(
                          "div",
                          {
                            staticClass: "search__filter-box-toggler",
                            on: { click: _vm.showInSection },
                          },
                          [_vm._v("Все разделы\n        ")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            Object.keys(_vm.page.sections).length && _vm.page.sections
              ? _c(
                  "div",
                  {
                    staticClass:
                      "search__filter-box search__filter-box_type_toggle",
                  },
                  [
                    _c("div", { staticClass: "search__filter-box-title" }, [
                      _vm._v("\n          в разделах каталога\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "search__filter-box-nav" }, [
                      _c("span", {
                        staticClass: "search__filter-box-nav-current",
                      }),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "search__filter-box-nav-list" },
                        _vm._l(
                          _vm.page.sections,
                          function (value, name, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                staticClass: "search__filter-box-nav-item",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "search__filter-box-nav-link",
                                    class: {
                                      hide:
                                        index >= _vm.maxSection &&
                                        !_vm.isShowMoreSections,
                                    },
                                    attrs: {
                                      href:
                                        "/catalog/" +
                                        name +
                                        "/?q=" +
                                        encodeURI(_vm.$route.query.q),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(value) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    Object.keys(_vm.page.sections).length > _vm.maxSection &&
                    !_vm.isShowMoreSections
                      ? _c(
                          "div",
                          {
                            staticClass: "search__filter-box-toggler",
                            on: { click: _vm.showSection },
                          },
                          [_vm._v("Все разделы\n        ")]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "catalog__header" }, [
        _c(
          "div",
          { staticClass: "filter" },
          [
            _c("FilterBox"),
            _vm._v(" "),
            _c("div", { staticClass: "filter__hint-result" }, [
              _vm._v("Найдено\n          "),
              _c("span", { staticClass: "data-length-span" }, [
                _vm._v(_vm._s(_vm.page.cnt)),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content__main" },
      [
        _c("notifications", {
          attrs: {
            group: _vm.groupNotify,
            closeOnClick: false,
            width: 500,
            max: 5,
            "animation-name": "v-fade-left",
            position: "top left",
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function (props) {
                return [
                  _c("div", { staticClass: "custom-template" }, [
                    _c("div", { staticClass: "custom-template-icon" }, [
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          attrs: {
                            target: "_blank",
                            href: props.item.data.url,
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: props.item.data.images.small.length
                                ? props.item.data.images.small[0]
                                : "/upload/empty/58.png",
                              width: "58",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "custom-template-content" }, [
                      _c("div", { staticClass: "custom-template-title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(props.item.title) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "custom-template-text",
                        domProps: { innerHTML: _vm._s(props.item.text) },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "custom-template-close",
                        on: {
                          click: function ($event) {
                            return _vm.close(props.item.data.id)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon icon-close" })]
                    ),
                  ]),
                ]
              },
            },
          ]),
        }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.page.name))]),
        _vm._v(" "),
        _vm.$route.path != "/search/"
          ? _c("breadcrumbs", {
              attrs: { items: _vm.page.breadcrumbs, name: _vm.page.name },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("modal-element", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isModalVisible,
              expression: "isModalVisible",
            },
          ],
          attrs: {
            item: _vm.item,
            user: _vm.page.user,
            cart: _vm.cart[_vm.item.id],
          },
          on: { close: _vm.closeModal },
        }),
        _vm._v(" "),
        _vm.isModalSertificateVisible
          ? _c("modal-sertificate", {
              attrs: { item: _vm.item },
              on: { close: _vm.closeModalSertificate },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isModalYoutubeVisible
          ? _c("modal-youtube", {
              attrs: { item: _vm.item },
              on: { close: _vm.closeModalYoutube },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("modal-images", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isModalImagesVisible,
              expression: "isModalImagesVisible",
            },
          ],
          attrs: { item: _vm.item },
          on: { close: _vm.closeModalImages },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "search__container" }, [
          _c(
            "div",
            { staticClass: "search__results-list" },
            [
              _c("SubmenuTree"),
              _vm._v(" "),
              _c("div", { staticClass: "catalog__controls pure-g" }, [
                _c("div", { staticClass: "pure-u-md-7-24 xs-hide" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "catalog__controls-page_view catalog__header-col catalog__header-col_inline",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "catalog__view-template view-template xs-hide",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "view-template__button",
                              class: { active: _vm.viewMode == "list" },
                              attrs: { "data-attr-view": "list" },
                              on: {
                                click: function ($event) {
                                  return _vm.changePageView("list")
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "view-template__button-icon icon icon-list",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "view-template__button",
                              class: { active: _vm.viewMode == "box" },
                              attrs: { "data-attr-view": "box" },
                              on: {
                                click: function ($event) {
                                  return _vm.changePageView("box")
                                },
                              },
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "view-template__button-icon icon icon-grid",
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pure-u-2-3 pure-u-md-10-24" },
                  [_c("SortBox")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pure-u-1-3 pure-u-md-7-24" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "catalog__controls-per_page catalog__header-col",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "sort catalog__sort sml-hide" },
                        [
                          _c("span", { staticClass: "sort__caption xs-hide" }, [
                            _vm._v("Показывать по:"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.arPerPage, function (index) {
                            return _c(
                              "a",
                              {
                                key: index,
                                staticClass: "sort__parametr",
                                class: { active: index == _vm.perPage },
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.setOnPage(index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(index))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("Pagination"),
              _vm._v(" "),
              _c("div", { staticClass: "catalog" }, [
                _c(
                  "div",
                  { staticClass: "catalog__list" },
                  [
                    _vm.isLoading
                      ? [_c("div", { staticClass: "loader" })]
                      : _vm.page.cnt > 0
                      ? _vm._l(_vm.page.items, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              staticClass: "product",
                              class: {
                                product_view_list: _vm.viewMode == "list",
                                product_view_box: _vm.viewMode == "box",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "product__content-inner" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "product__picture" },
                                    [
                                      item.badge.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "product__badges" },
                                            [
                                              item.badge.includes("hit")
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__badge",
                                                    },
                                                    [_vm._v("Хит")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.badge.includes("new")
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__badge",
                                                    },
                                                    [_vm._v("Новинка")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.badge.includes("action")
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__badge",
                                                    },
                                                    [_vm._v("Акция")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "slider-product-image product__picture-slider",
                                        },
                                        [
                                          item.images.small.length > 0
                                            ? [
                                                _c("vue-swiper", {
                                                  key: item.id,
                                                  attrs: {
                                                    images: item.images.small,
                                                    "item-id": item.id,
                                                    isZoom: false,
                                                  },
                                                }),
                                              ]
                                            : [_vm._m(0, true)],
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      item.badge.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product__bottom-badges",
                                            },
                                            [
                                              item.badge.includes(
                                                "pack_damaged"
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__badge",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Повреждена упаковка"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "product__to_favorite",
                                          on: {
                                            click: function ($event) {
                                              return _vm.toFavorite(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "icon",
                                            class: {
                                              "icon-heart": !item.favorite,
                                              "icon-heart-full": item.favorite,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "product__main-info" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "product__options-info",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "product__options-info-item",
                                            },
                                            [
                                              _vm._v(
                                                "Код:\n                        "
                                              ),
                                              _c(
                                                "vue-popper",
                                                {
                                                  attrs: {
                                                    id: item.id + "-xmlid",
                                                    hint: "Копировать",
                                                    "hint-click": "Скопировано",
                                                  },
                                                  on: { hinted: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.code))]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "product__options-info-item",
                                            },
                                            [
                                              _vm._v(
                                                "Артикул:\n                        "
                                              ),
                                              _c(
                                                "vue-popper",
                                                {
                                                  attrs: {
                                                    id: item.id + "-vendorCode",
                                                    hint: "Копировать",
                                                    "hint-click": "Скопировано",
                                                  },
                                                  on: { hinted: _vm.copy },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.vendorCode)
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "product__options-info-item",
                                            },
                                            [
                                              _vm._v(
                                                "Штрих-код:\n                        "
                                              ),
                                              _c(
                                                "vue-popper",
                                                {
                                                  attrs: {
                                                    id: item.id + "-barcode",
                                                    hint: "Копировать",
                                                    "hint-click": "Скопировано",
                                                  },
                                                  on: { hinted: _vm.copy },
                                                },
                                                [_vm._v(_vm._s(item.barcode))]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "product__name element-view-button",
                                          attrs: {
                                            href: item.url,
                                            "element-url": item.url,
                                            "element-id": item.id,
                                            "section-id": item.section_id,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.showModal(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.name) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.page.user.isAuthorized
                                        ? _c("product-statuses", {
                                            attrs: { item: item },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        { staticClass: "product__options" },
                                        [
                                          item.dimensions.size
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "product__options-item",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__options-item-caption",
                                                    },
                                                    [_vm._v("Размер(ШхВxГ)")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__options-item-value",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.dimensions.size
                                                        ) + " см"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            item.properties,
                                            function (pval, pkey) {
                                              return [
                                                pval.code == "TorgovayaMarka" ||
                                                pval.code == "Litsenziya"
                                                  ? _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "product__options-item",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "product__options-item-caption",
                                                          },
                                                          [_vm._v(_vm._s(pkey))]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "product__options-item-value",
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href: pval.url,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    pval.text
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                          _vm._v(" "),
                                          item.licenses.length > 0
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "product__options-item",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__options-item-caption",
                                                    },
                                                    [_vm._v("Лицензии")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "product__options-item-value",
                                                      staticStyle: {
                                                        display: "grid",
                                                      },
                                                    },
                                                    _vm._l(
                                                      item.licenses,
                                                      function (lval, lkey) {
                                                        return _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: lval.url,
                                                              target: "_blank",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(lval.text)
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      item.certificates.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product__action-link product__action-link_sertificat popup-image-gallery",
                                              staticStyle: {
                                                float: "left",
                                                "margin-right": "20px",
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "product__action-link-text",
                                                  attrs: {
                                                    href:
                                                      "/upload/cert/" +
                                                      item.certificates[0],
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.showModalSertificate(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "product__action-link-icon icon icon-sertificat",
                                                  }),
                                                  _vm._v(
                                                    "\n                        Сертификат\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.youtube_id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product__action-link product__action-link_sertificat popup-image-gallery",
                                              staticStyle: {
                                                position: "unset",
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video",
                                                  attrs: {
                                                    target: "_blank",
                                                    title: "Видео",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.showYoutube(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticStyle: {
                                                      height: "25px",
                                                    },
                                                    attrs: {
                                                      src: "/img/youtube.png",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.manual
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product__action-link product__action-link_sertificat popup-image-gallery",
                                              staticStyle: {
                                                position: "unset",
                                              },
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video",
                                                  attrs: {
                                                    target: "_blank",
                                                    href:
                                                      "/upload/manuals/" +
                                                      item.vendorCode +
                                                      ".pdf",
                                                    title: "Инструкция",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticStyle: {
                                                      height: "25px",
                                                    },
                                                    attrs: {
                                                      src: "/img/pdf.png",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !item.is_archive
                                    ? _c(
                                        "div",
                                        { staticClass: "product__actions" },
                                        [
                                          _vm.page.user.isAuthorized
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "product__noreg-box",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "product__prices",
                                                    },
                                                    [
                                                      item.price.stock !=
                                                      item.price.price
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "product__price product__price_type_old",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    Math.round(
                                                                      item.price
                                                                        .stock *
                                                                        item.step *
                                                                        100
                                                                    ) / 100
                                                                  ) +
                                                                  " Р.\n                          "
                                                              ),
                                                              item.price.type ==
                                                              "MANUAL"
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "percent-badge__value",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "vue-popper",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  id:
                                                                                    item.id +
                                                                                    "-el-percent",
                                                                                  hint: "Ваша перональная скидка на данную категорию товаров",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item
                                                                                    .price
                                                                                    .percent
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "percent-badge percent-badge_theme_red percent-badge_size_xs product__price-percent",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "percent-badge__value",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item
                                                                                .price
                                                                                .percent
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "product__price",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                Math.round(
                                                                  item.price
                                                                    .price *
                                                                    item.step *
                                                                    100
                                                                ) / 100
                                                              ) +
                                                              " Р.\n                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "product-summary-controls",
                                                    {
                                                      attrs: {
                                                        item: item,
                                                        cartCount:
                                                          _vm.cart[item.id],
                                                        productId: item.id,
                                                        v: item.dimensions
                                                          .volume,
                                                        x: item.code,
                                                      },
                                                    }
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "product__noreg-box-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        Видеть цены и покупать могут только зарегистрированные пользователи\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "product__noreg-box-button button button_theme_primary_blue button_size_md",
                                                    attrs: {
                                                      href:
                                                        "/auth/?login=yes&backurl=" +
                                                        _vm.back_url,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "button__text",
                                                      },
                                                      [_vm._v("Войти и купить")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/auth/?register=yes&backurl=" +
                                                        _vm.back_url,
                                                    },
                                                  },
                                                  [_vm._v("Зарегистрироваться")]
                                                ),
                                              ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        })
                      : [
                          _c("div", { staticClass: "search" }, [
                            _c("h1", { staticClass: "content__page-title" }, [
                              _vm._v(
                                "\n                  По Вашему запросу ничего не найдено\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "content__page-description-text" },
                              [
                                _vm.$route.path == "/search_archive/"
                                  ? _c("p", [
                                      _vm._v(
                                        "\n                    Советуем изменить поисковый запрос\n                  "
                                      ),
                                    ])
                                  : _c(
                                      "p",
                                      [
                                        _vm.page.altQuery
                                          ? [
                                              _vm._v(
                                                '\n                      Возможно вы искали "'
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "/search/?q=" +
                                                      encodeURI(
                                                        _vm.page.altQuery
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.page.altQuery)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                '"?\n                    '
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        [
                                          _vm._v(
                                            "\n                      Также советуем изменить запрос или поискать в "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  "/search_archive/?q=" +
                                                  encodeURI(_vm.$route.query.q),
                                              },
                                            },
                                            [_vm._v("архиве")]
                                          ),
                                        ],
                                      ],
                                      2
                                    ),
                              ]
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("Pagination"),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumb-image img-content" }, [
      _c("img", { attrs: { src: "/img/empty-300.png" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }